/*
 * Design: Swiss Precision × 和の余白
 * 東洋電設株式会社（Google Workspace 認定パートナー）との連携を明示
 * Mobile: 余白・フォントサイズ調整、バッジの横スクロール対応
 */

import { motion } from "framer-motion";
import { Shield, Building2, Wrench, Award } from "lucide-react";

const fadeInUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
};

export function PartnerSection() {
  return (
    <section className="py-10 sm:py-14 lg:py-16 bg-white border-y border-[#E0E0E0]">
      <div className="container">
        <motion.div
          {...fadeInUp}
          transition={{ duration: 0.6 }}
          className="flex flex-col lg:flex-row items-start lg:items-center gap-5 sm:gap-8 lg:gap-12"
        >
          {/* Left: Partner Badge */}
          <div className="shrink-0 flex items-center gap-3 sm:gap-5">
            <div className="w-11 h-11 sm:w-14 sm:h-14 flex items-center justify-center bg-white border border-[#E0E0E0] rounded-sm shadow-sm shrink-0">
              <Award size={22} className="text-[#E03030] sm:hidden" />
              <Award size={28} className="text-[#E03030] hidden sm:block" />
            </div>
            <div>
              <div className="text-[9px] sm:text-xs text-[#666666] font-medium tracking-wider uppercase mb-0.5 sm:mb-1" style={{ fontFamily: "'Inter', sans-serif" }}>
                Implementation Partner
              </div>
              <div className="text-sm sm:text-base font-bold text-[#1A1A1A]">
                Google Workspace 認定パートナー連携
              </div>
            </div>
          </div>

          {/* Right: Description */}
          <div className="flex-1">
            <p className="text-xs sm:text-sm text-[#333333] leading-relaxed mb-3 sm:mb-4">
              81合同会社は、<span className="font-bold">東洋電設株式会社</span>（Google Workspace 認定パートナー）との連携により、
              Google Workspaceの初期設定・運用を含めた実装を支援します。
              DXの構想設計から技術実装まで、パートナーシップによる確かな実行力をご提供します。
            </p>

            {/* Partner Strengths */}
            <div className="flex flex-col sm:flex-row sm:flex-wrap gap-2 sm:gap-4">
              <div className="inline-flex items-center gap-2 text-[11px] sm:text-xs text-[#333333] bg-white border border-[#E0E0E0] px-3 py-2">
                <Shield size={14} className="text-[#E03030] shrink-0" />
                認定パートナーによる公式サポート
              </div>
              <div className="inline-flex items-center gap-2 text-[11px] sm:text-xs text-[#333333] bg-white border border-[#E0E0E0] px-3 py-2">
                <Building2 size={14} className="text-[#E03030] shrink-0" />
                東洋電設株式会社との技術連携
              </div>
              <div className="inline-flex items-center gap-2 text-[11px] sm:text-xs text-[#333333] bg-white border border-[#E0E0E0] px-3 py-2">
                <Wrench size={14} className="text-[#E03030] shrink-0" />
                実装設計から運用定着まで一気通貫
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
